import { Box, Typography } from '@mui/material';
import { Dispatch } from 'react';
import { ModalAction } from '../../../../../../../model/modal.model';
import zeplinColor from '../../../../../../../theme/Color';
import CustomCard from '../../../../../../shared/CustomCard/CustomCard';
import CustomModal from '../../../../../../shared/CustomModal/CustomModal';
import { HistoryRecord } from './HistoryRecord';

export const RoleHistory = ({
  modalDispatch,
  isModalOpen,
}: {
  modalDispatch: Dispatch<ModalAction>;
  isModalOpen: boolean;
}) => {
  return (
    <CustomModal
      handleClose={() => modalDispatch({ type: 'CLOSE', payload: 'history' })}
      open={isModalOpen}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: { xs: '20px', xl: '24px' },
            backgroundColor: zeplinColor.Neutral1,
            width: '538px',
            maxHeight: '460px',
            overflow: 'scroll',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              marginBottom: '52px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                Test: Role History
              </Typography>
              <img
                src={'/assets/close-icon.svg'}
                alt='close'
                style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                onClick={() => modalDispatch({ type: 'CLOSE', payload: 'history' })}
              />
            </Box>
            <Typography
              variant='body3'
              sx={{
                color: zeplinColor.Neutral9,
              }}
            >
              Track all updates made to this role's permissions.
            </Typography>
          </Box>

          <HistoryRecord />
        </CustomCard>
      </Box>
    </CustomModal>
  );
};
